<template>
  <div class="">
    <el-container>
      <el-header style="margin-bottom: 20px">
        <div class="max-w1280 nav-bar">
          <img src="../assets/MDS.png" style="margin-top: 10px" height="60px" alt="" />

          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo animate__animated animate__slideInRight"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1">
              {{ this.lang == "EN" ? "首页" : "Home" }}</el-menu-item
            >
            <el-menu-item index="2">{{
              this.lang == "EN" ? "我们" : "About Us"
            }}</el-menu-item>
            <el-menu-item index="3">{{
              this.lang == "EN" ? "服务" : "Service"
            }}</el-menu-item>
            <el-menu-item index="4">{{
              this.lang == "EN" ? "动态" : "News"
            }}</el-menu-item>
            <el-menu-item index="5">{{
              this.lang == "EN" ? "分布" : "Distribution"
            }}</el-menu-item>
            <el-menu-item index="6">{{
              this.lang == "EN" ? "诚聘" : "Recruitment"
            }}</el-menu-item>
            <el-menu-item index="7">{{
              this.lang == "EN" ? "联系" : "Contact"
            }}</el-menu-item>
            <el-menu-item
              index="8"
              disabled
              style="opacity: 1; cursor: pointer"
              @click.native="langClick"
              >{{ lang }}</el-menu-item
            >
          </el-menu>
        </div>
      </el-header>
      <el-main class="main">
        <div>
          <el-carousel :interval="4000" height="500px" indicator-position="outside">
            <el-carousel-item v-for="(item, index) in carousels" :key="index">
              <img :src="item.url" alt="" width="1280px" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="max-w1280" style="min-height: 600px">
          <Index
            v-if="activeIndex == 1"
            @newItemClick="newItemClick"
            @serviceClick="serviceClick"
            :lang="lang"
          />
          <AboutUs v-if="activeIndex == 2" :lang="lang" @toHome="toHome" />
          <Service v-if="activeIndex == 3" ref="service" :lang="lang" @toHome="toHome" />
          <Behavior
            ref="behavior"
            v-if="activeIndex == 4"
            :lang="lang"
            @toHome="toHome"
          />
          <Distribution v-if="activeIndex == 5" :lang="lang" @toHome="toHome" />
          <Recruitment v-if="activeIndex == 6" :lang="lang" @toHome="toHome" />
          <Contact v-if="activeIndex == 7" :lang="lang" @toHome="toHome" />
        </div>
      </el-main>
      <el-footer height="180px" style="font-size: 14px; margin-top: 40px">
        <Footer :lang="lang" />
        <!-- 版权所有合肥脉律臣道医学科技有限公司 京ICP备xxxx号 Copyright © 2020 mds
        lnc. All Rights Reserved -->
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Index from "@/components/Index";
import AboutUs from "@/components/AboutUs";
import Behavior from "@/components/Behavior.vue";
import Contact from "@/components/Contact.vue";
import Distribution from "@/components/Distribution.vue";
import Recruitment from "@/components/Recruitment.vue";
import Service from "@/components/Service.vue";
import Footer from "@/components/Footer.vue";
import { setTimeout } from "timers";

import { getCarousels } from "@/api/data.js";

export default {
  name: "Home",
  components: {
    Index,
    AboutUs,
    Behavior,
    Contact,
    Distribution,
    Recruitment,
    Service,
    Footer,
  },
  props: {
    msg: String,
  },

  data() {
    return {
      activeIndex: "1",
      lang: "EN",
      showNews: false,
      carousels: [],
    };
  },
  mounted() {
    this.getCarousels();
  },
  methods: {
    toHome() {
      this.activeIndex = "1";
    },

    getCarousels() {
      let that = this;
      getCarousels()
        .then((response) => {
          if (response.status == 200) {
            that.carousels = response.data.data;
          } else {
            that.carousels = [];
          }
        })
        .catch((error) => {
          if (error.message.indexOf("401") != -1) {
            window.location.reload(true);
          }
          console.log(error);
          that.carousels = [];
        });
    },

    langClick() {
      if (this.lang == "EN") {
        this.lang = "简体中文";
      } else {
        this.lang = "EN";
      }
    },

    handleSelect(val) {
      console.log(val);
      this.activeIndex = val;
      let that = this;
      if (val == "4") {
        setTimeout(function () {
          that.$refs.behavior.cleanNews();
          that.$refs.behavior.getData();
        }, 50);
      }
    },

    serviceClick(data) {
      this.activeIndex = "3";
      let that = this;
      console.log(data);
      setTimeout(function () {
        that.$refs.service.setActiveItem(data.id);
      }, 50);
    },

    newItemClick(news) {
      this.activeIndex = "4";
      let that = this;
      setTimeout(function () {
        that.$refs.behavior.setActiveItem(news);
      }, 50);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-footer {
  line-height: 40px !important;
}
.page-content {
  max-width: 1280px;
  margin: 0 auto;
  margin-top: 20px;
}

.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  line-height: 120px;
}
.max-w1280 {
  max-width: 1280px;
  margin: 0 auto;
}
.h150 {
  height: 150px;
  position: relative;
}
.el-header {
  text-align: center;
  line-height: 60px;
}
.el-footer {
  text-align: center;
  line-height: 60px;
  height: 150px;
  background-color: #282a2b;
  border-color: #4b4c4d;
  color: #fff;
}

.el-aside {
  text-align: center;
  line-height: 200px;
}

.el-main {
  text-align: center;
  line-height: 160px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.page-main {
  display: flex;
}

.el-carousel__indicators--outside {
  line-height: normal;
}
.el-main {
  line-height: normal;
  padding-top: 0;
}

.main {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.main::-webkit-scrollbar {
  display: none;
}
</style>
